export const UsersReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_TABLE_DATA':
      return {
        ...state,
        data: payload.data,
        search: payload.search,
        nextPageToken: payload.nextPageToken,
        loading: false,
        error: false,
        msLoaded: Date.now(),
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    case 'SET_FAILURE':
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      }
    case 'SET_STATUS_COUNT_LOADING':
      return {
        ...state,
        statusCountLoading: true,
      }
    case 'SET_STATUS_COUNT':
      return {
        ...state,
        statusCount: payload,
        statusCountLoading: false,
      }
    case 'SET_STATUS_COUNT_FAILURE':
      return {
        ...state,
        statusCountLoading: false,
      }
    default:
      throw new Error('unknown action')
  }
}
